import { Trigger } from '@radix-ui/react-dialog'
import { Button, type ButtonProps } from '@seen/ui'
import { type ElementRef, forwardRef } from 'react'

/**
 * Includes data attributes from Trigger:
 *   [data-state]: "open" | "closed"
 */
export type DialogButtonProps = ButtonProps

export const DialogButton = forwardRef<
  ElementRef<typeof Trigger>,
  DialogButtonProps
>((props, ref) => (
  <Trigger ref={ref} asChild>
    <Button {...props} />
  </Trigger>
))
DialogButton.displayName = Trigger.displayName
